import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import logoWhite from '../assets/img/logo-white.svg';

class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="credits">
                    <p>{t("general.poweredBy")}</p><a href={`https://www.lockself.com/?utm_source=${window.location.host}`} target="_blank" rel="noopener noreferrer"><img src={logoWhite} alt="lockself logo" /></a>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Footer);
